import { useEffect } from 'react';
// eslint-disable-next-line max-len
import { type StandardApplicationPublicAccessEntrypointContextDataFragment } from '../../../../api/fragments/StandardApplicationPublicAccessEntrypointContextData';
import { useMultipleDealerIds, useDealerContext } from '../../../../components/contexts/DealerContextManager';
import useTranslatedString from '../../../../utilities/useTranslatedString';
import CarListingPageInner from '../../StandardApplicationEntrypoint/CarListingPage/CarListingPageInner';
import CarListingStateProvider from '../../StandardApplicationEntrypoint/CarListingPage/useCarListingState';

export type CarListingPageProps = {
    endpoint: StandardApplicationPublicAccessEntrypointContextDataFragment;
};

const CarListingPage = ({ endpoint }: CarListingPageProps) => {
    const { dealerIds, setAllVisible } = useMultipleDealerIds();
    const { setDealerOptions, setDisplayDropdown } = useDealerContext();
    const translated = useTranslatedString();
    useEffect(() => {
        if (endpoint.dealers.length > 0) {
            const dealerOption = endpoint.dealers.map(dealer => ({
                value: dealer.id,
                label: translated(dealer.legalName),
            }));
            setDealerOptions(dealerOption);
            setDisplayDropdown(true);
        }
        setAllVisible();
    }, []);

    return (
        <CarListingStateProvider dealerIds={dealerIds} endpoint={endpoint}>
            <CarListingPageInner dealerIds={dealerIds} />
        </CarListingStateProvider>
    );
};

export default CarListingPage;
